import { BaseEditor, Editor } from 'slate';
import { ReactEditor } from 'slate-react';

export const getBlockMark = (editor: BaseEditor & ReactEditor, format: 'fontSize' | 'fontType'): any | null => {
  const marks = Editor.marks(editor);

  return marks ? marks[format] : null;
};
